import React, {useState} from 'react'
import {Button} from "antd";
import {getEmployeeById} from "../../services/serviceEmployee";
import EmployeeEditFormatter from "./EmployeeEditFormatter";


const EmployeeEdit = ({employee, updater}) => {
    const [editModal, setEditModal] = useState(false)
    const [employeeData, setEmployeeData] = useState({})

    const handleEditClick = () => {
        getEmployeeById(employee.id)
            .then(({data}) => {
                setEmployeeData(data)
                setEditModal(!editModal)
            })
    }

    return (
        <React.Fragment>
            <Button type={'link'} onClick={() => handleEditClick()}> Güncelle </Button>

            {editModal ? <EmployeeEditFormatter employee={employeeData} show={editModal}  updater={updater} modalCloser={setEditModal}/>: null}

        </React.Fragment>
    )
}
export default EmployeeEdit